import { jsx as _jsx } from "preact/jsx-runtime";
import convertDataAttributes from '@bookingForm/convertDataAttributes';
import { useMemo } from 'react';
import { multiActivitySchema, } from '@widgets/GenericBookings/validation/schema';
import defaultValues from '@widgets/DIYDayTickets/context/defaultValues';
import { OptionsCTX, optionsDefaults } from '@widgets/DIYDayTickets/context/Options';
import BookingFormWrapper from '@genericBookings/components/BookingFormWrapper';
import BuilderFormSteps from '@genericBookings/types/BuilderFormSteps';
import Form from '@widgets/DIYDayTickets/components/Form';
function DIYDayTickets(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formOptions = useMemo(() => ({
        ...optionsDefaults,
        ...formattedAttributes,
        showPriceOnBands: false,
        isMulti: true,
        isBuilder: true,
        debug: false,
    }), [formattedAttributes]);
    // TODO: Add price bands to data-activities and use these. Current implementation not correct.
    const { dayTicketId, hideQuickPayButtons } = formOptions;
    return (_jsx(BookingFormWrapper, { schema: multiActivitySchema, defaultValues: {
            ...defaultValues,
            DayTicketId: dayTicketId ?? 4,
            acceptTerms: hideQuickPayButtons ? true : defaultValues.acceptTerms,
            Sessions: [],
        }, OptionsCTX: OptionsCTX, steps: BuilderFormSteps, options: formOptions, theme: (formattedAttributes.theme ?? {}), children: _jsx(Form, {}) }));
}
export default DIYDayTickets;
